import { applyTheme } from "./slide-themes";

// Raw slide data - just content, no styling
const pcafSlidesData = [
  {
    id: "pcaf-overview",
    image: "/sliders/pcaf/1_pcaf.png",
    imageAlt: "PCAF overview",
    imagePosition: "left",
    kicker: "Financed Emissions",
    title: "PCAF",
    sections: [
      {
        description: [
          "Adopt the Partnership for Carbon Accounting Financials (PCAF) standard with confidence.",
          "Measure and disclose financed emissions consistently across asset classes.",
          "Gain transparency, comparability, and regulatory alignment for investors and supervisors.",
        ],
      },
    ],
  },
  {
    id: "2_financed_emissions_portfolio_management",
    image: "/sliders/pcaf/2_financed_emissions_portfolio_management.png",
    imageAlt: "Financed Emissions Portfolio Management",
    imagePosition: "right",
    title: "Portfolio-wide emissions management",
    sections: [
      {
        description: [
          "Deliver consistent financed-emissions tracking from headquarters to branches.",
          "Combine CTBC's regional PCAF leadership with Evercomm's award-winning platform.",
          "Scale from pilot portfolios to enterprise-wide reporting without rework.",
        ],
      },
    ],
  },
  {
    id: "3_support_financial_institutions",
    image: "/sliders/pcaf/3_support_financial_institutions.png",
    imageAlt: "Support Financial Institutions",
    imagePosition: "left",
    title: "Purpose-built for financial institutions",
    sections: [
      {
        description: [
          "Automate financed-emission calculations with configurable data quality scores.",
          "Assess climate risks at portfolio, sector, and obligor levels with ease.",
          "Stay in lockstep with MAS, HKMA, and global disclosure expectations.",
        ],
      },
    ],
  },
  {
    id: "4_data_driven_sustainable_finance",
    image: "/sliders/pcaf/4_data_driven_sustainable_finance.png",
    imageAlt: "Data-Driven Sustainable Finance",
    imagePosition: "left",
    title: "Data-driven sustainable finance",
    sections: [
      {
        description: [
          "Blend financed-emission insights with scenario analysis to steer lending strategies.",
          "Set credible decarbonisation targets and measure progress with live dashboards.",
          "Support climate-aligned products and investment decisions with reliable data.",
        ],
      },
    ],
  },
];

// Apply themes to slides - alternating between amber and amberEmerald
export const pcafSlides = pcafSlidesData.map((slide, index) => {
  const theme = index % 2 === 0 ? "amber" : "amberEmerald";
  return applyTheme(slide, theme, "amber");
});
